import { FunctionComponent } from 'react';

import styles from './Separator.module.sass';

const Separator: FunctionComponent = () => {
    return <hr className={styles.separator} />;
};

export default Separator;
